import {i18nClient} from '@sailor/i18n-mach-pro';
import resources from './resources';

i18nClient.init(
    {
        defaultNS: 'translation',
        fallbackLng: 'zh-HK',
        fallbackNS: 'translation',
        resources,
    }
);

export default i18nClient;
